import React from 'react'
import './header.css'
import CTA from './CTA'
import HeaderSocial from './headerSocials'

const header = () => {
  return (
    <header id="top">
      <div className="container header__container">
        <h5>Product-minded technologist</h5>
        <h1>Michael Fang</h1>
        <h5 className="text-light">Building practical AI tools, clear user experiences, and dependable workflows.</h5>
        <CTA />
        <HeaderSocial />

        <a href="#about" className='scroll__down'>Explore</a>
      </div>
    </header>
  )
}

export default header
